import request from '@/utils/zsm-requets'
const giveEntity = '/zsm/api/giveEntity/' // 买赠

/**
 * 保存单个赠品信息
 * @param title  名称
 * @param goodId 商品id
 * @param goodName 商品名称
 * @param openFlag  启用状态 1.开启 0.关闭
 * @param auditFlag   获取场景 1.提交抖音审核 2.不提交
 * @param sendBackPolicyStatus 0：退款不需要退还赠品 1：需要退还赠品
 * @param sendBackPolicyDesc 退款策略描述
 * @param sellGoodGiveEntity 详情内容 images图片   title标题
 * @returns {*}
 */
export function saveGiveEntityDetail(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: giveEntity + 'save',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}

/**
 * 获取赠品列表
 * @param title  名称
 * @param goodId 商品id
 * @param goodName 商品名称
 * @param openFlag  启用状态 1.开启 0.关闭
 * @param auditFlag   获取场景 1.提交抖音审核 2.不提交
 * @param sendBackPolicyStatus 0：退款不需要退还赠品 1：需要退还赠品
 * @param sendBackPolicyDesc 退款策略描述
 * @param sellGoodGiveEntity 详情内容 images图片   title标题
 * @param pageNo 分页
 * @param pgaeSize 当前页数
 * @returns {*}
 */
export function listDataGiveEntity(params) {
  return request({
    url: giveEntity + 'listData',
    method: 'post',
    params
  })
}

/**
 * 修改附赠实物状态
 * @param openFlag  1.开启 0.关闭
 * @param id 当前附赠实物的id
 * @returns {*}
 */
export function modifyOpenFlag(id, openFlag) {
  return request({
    url: giveEntity + 'modifyOpenFlag',
    method: 'post',
    params: { id, openFlag }
  })
}

/**
 * 获取单个赠送信息
 * @param id 当前附赠实物的id
 * @returns {AxiosPromise}
 */
export function getGiveEntity(id) {
  return request({
    url: giveEntity + 'get',
    method: 'post',
    params: { id }
  })
}

/**
 * 删除单个赠送信息
 * @param id 当前附赠实物的id
 * @returns {AxiosPromise}
 */
export function deleteGiveEntity(id) {
  return request({
    url: giveEntity + 'delete',
    method: 'post',
    params: { id }
  })
}

/**
 * 查询赠品发货信息分页数据
 * @param teacherMobile 讲师账号
 * @param sendStatus 发货状态
 * @param orderNo 订单号
 * @param goodId 商品id
 * @param payFlag 支付状态
 * @param {goodGiveEntity} 赠送实物信息 title 标题 goodName商品标题
 * @returns {AxiosPromise}
 */
export function queryOrderGiveEntitySendPageData(params) {
  return request({
    url: giveEntity + 'queryOrderGiveEntitySendPageData',
    method: 'post',
    params
  })
}

/**
 * 保存赠品发货状信息
 * @param remarks 备注
 * @param sendStatus 发货状态
 * @param teacherMobile 讲师账号
 * @param sendNo 发货单号
 * @param payFlag 支付状态
 * @param goodId 商品id
 * @param orderNo 关联单号
 * @returns {AxiosPromise}
 */

export function saveOrderGiveEntitySend(params) {
  return request({
    url: giveEntity + 'saveOrderGiveEntitySend',
    method: 'post',
    params
  })
}

/**
 * 修改赠品发货状态
 * @param sendStatus 	1.已发货 0.未发货
 * @param id 键值id
 * @returns {AxiosPromise}
 */

export function modifyOrderGiveEntitySendStatus(params) {
  return request({
    url: giveEntity + 'modifyOrderGiveEntitySendStatus',
    method: 'post',
    params
  })
}


/**
 * excel保存赠品发货信息
 * @param sendStatus 	1.已发货 0.未发货
 * @param orderNo 订单号
 * @param sendNo 物流单号
 * @param id 键值id
 * @returns {AxiosPromise}
 */

export function modifyOrderGiveEntitySendByExcel(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: giveEntity + 'modifyOrderGiveEntitySendByExcel',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}


